import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// ── Accounts ────────────────────────────────────────────
export const mailAccountList = (params = '') => Http.get(`/mail/accounts${serialize(params)}`)
export const mailAccountById = id => Http.get(`/mail/accounts/${id}`)
export const mailAccountCreate = data => Http.post('/mail/accounts', data)
export const mailAccountUpdate = (id, data) => Http.put(`/mail/accounts/${id}`, data)
export const mailAccountDestroy = id => Http.delete(`/mail/accounts/${id}`)
export const mailAccountTest = id => Http.post(`/mail/accounts/${id}/test`)
export const mailAccountSync = id => Http.post(`/mail/accounts/${id}/sync`)
export const mailAccountToggleAutoReply = (id, data = {}) => Http.patch(`/mail/accounts/${id}/toggle-auto-reply`, data)

// ── Inbox (Threads) ─────────────────────────────────────
export const mailInboxList = (params = '') => Http.get(`/mail/inbox${serialize(params)}`)
export const mailInboxMessages = (params = '') => Http.get(`/mail/inbox/messages${serialize(params)}`)
export const mailInboxStats = (params = '') => Http.get(`/mail/inbox/stats${serialize(params)}`)
export const mailPendingCount = () => Http.get('/mail/inbox/pending-count')
export const mailSpamPreview = (data = {}) => Http.get('/mail/inbox/spam-preview', { params: data })
export const mailSpamClean = (data = {}) => Http.post('/mail/inbox/spam-clean', data)

// ── Threads ─────────────────────────────────────────────
export const mailThreadById = id => Http.get(`/mail/threads/${id}`)
export const mailThreadMessages = (id, params = '') => Http.get(`/mail/threads/${id}/messages${serialize(params)}`)
export const mailThreadUpdate = (id, data) => Http.patch(`/mail/threads/${id}`, data)
export const mailThreadArchive = id => Http.post(`/mail/threads/${id}/archive`)
export const mailThreadUnarchive = id => Http.post(`/mail/threads/${id}/unarchive`)
export const mailThreadMute = id => Http.post(`/mail/threads/${id}/mute`)
export const mailThreadUnmute = id => Http.post(`/mail/threads/${id}/unmute`)
export const mailThreadDelete = id => Http.delete(`/mail/threads/${id}`)

// ── AI Profiles ───────────────────────────────────────
export const mailAiProfiles = () => Http.get('/mail/ai-profiles')
export const mailBatchCategorize = (data = {}) => Http.post('/mail/batch-categorize', data)

// ── Response Templates ────────────────────────────────
export const mailResponseTemplateList = (params = '') => Http.get(`/mail/response-templates${serialize(params)}`)
export const mailResponseTemplateCreate = data => Http.post('/mail/response-templates', data)
export const mailResponseTemplateUpdate = (id, data) => Http.put(`/mail/response-templates/${id}`, data)
export const mailResponseTemplateDestroy = id => Http.delete(`/mail/response-templates/${id}`)

// ── Analysis (Phase 2) ─────────────────────────────────
export const mailMessageDestroy = messageUuid => Http.delete(`/mail/messages/${messageUuid}`)
export const mailMessageAnalysis = messageUuid => Http.get(`/mail/messages/${messageUuid}/analysis`)
export const mailMessageAnalysisHistory = (messageUuid, params = '') => Http.get(`/mail/messages/${messageUuid}/analysis/history${serialize(params)}`)
export const mailMessageReanalyze = (messageUuid, data = {}) => Http.post(`/mail/messages/${messageUuid}/reanalyze`, data)
export const mailMessageAnalyzeNow = (messageUuid, data = {}) => Http.post(`/mail/messages/${messageUuid}/analyze-now`, data, { timeout: 60000 })

// ── Suggestions (Phase 2) ──────────────────────────────
export const mailSuggestionList = (params = '') => Http.get(`/mail/suggestions${serialize(params)}`)
export const mailSuggestionById = id => Http.get(`/mail/suggestions/${id}`)
export const mailSuggestionUpdate = (id, data) => Http.patch(`/mail/suggestions/${id}`, data)

// ── Outbound / Reply (Phase 3) ─────────────────────────
export const mailCreateReply = (messageUuid, data) => Http.post(`/mail/messages/${messageUuid}/replies`, data)
export const mailOutboundList = (params = '') => Http.get(`/mail/outbound${serialize(params)}`)
export const mailOutboundById = id => Http.get(`/mail/outbound/${id}`)
export const mailOutboundUpdate = (id, data) => Http.patch(`/mail/outbound/${id}`, data)
export const mailOutboundSend = id => Http.post(`/mail/outbound/${id}/send`)
export const mailOutboundSchedule = (id, data) => Http.post(`/mail/outbound/${id}/schedule`, data)
export const mailOutboundDelete = id => Http.delete(`/mail/outbound/${id}`)

// ── Leads (Phase 4) ────────────────────────────────────
export const mailLeadList = (params = '') => Http.get(`/mail/leads${serialize(params)}`)
export const mailLeadById = id => Http.get(`/mail/leads/${id}`)
export const mailLeadUpdate = (id, data) => Http.patch(`/mail/leads/${id}`, data)
export const mailLeadInteractions = (id, params = '') => Http.get(`/mail/leads/${id}/interactions${serialize(params)}`)
export const mailLeadEnrich = id => Http.post(`/mail/leads/${id}/enrich`)
export const mailLeadAddNote = (id, data) => Http.post(`/mail/leads/${id}/notes`, data)
export const mailLeadFunnelStats = (params = '') => Http.get(`/mail/leads/funnel-stats${serialize(params)}`)
export const mailLeadScheduleMeeting = (id, data) => Http.post(`/mail/leads/${id}/meeting`, data)
export const mailLeadGenerateProposal = (id, data) => Http.post(`/mail/leads/${id}/proposal`, data)
export const mailLeadProposalPdf = (id, documentId) => Http.get(`/mail/leads/${id}/proposal/${documentId}/pdf`, { responseType: 'blob' })
export const mailLeadCompanyContext = id => Http.get(`/mail/leads/${id}/company-context`)

// ── Sent / Delivery (Phase 5) ──────────────────────────
export const mailSentList = (params = '') => Http.get(`/mail/sent${serialize(params)}`)
export const mailSentStats = (params = '') => Http.get(`/mail/sent/stats${serialize(params)}`)
export const mailSentDeliveryEvents = id => Http.get(`/mail/sent/${id}/delivery-events`)
export const mailSuppressedContacts = (params = '') => Http.get(`/mail/sent/suppressed${serialize(params)}`)

// ── Contacts / Suppression ─────────────────────────────
export const mailContactLookup = email => Http.get(`/mail/contacts/lookup${serialize({ email })}`)
export const mailContactSuppress = data => Http.post('/mail/contacts/suppress', data)
export const mailContactUnsuppress = data => Http.post('/mail/contacts/unsuppress', data)

// ── Settings (admin-editable configuration) ────────────
export const mailHubSettings = () => Http.get('/mail/settings')
export const updateMailHubSettings = params => Http.put('/mail/settings', params)

// ── Studio Key Requests ("Ask Studio for Keys") ────────
export const studioKeyRequestList = (params = '') => Http.get(`/mail/key-requests-studio${serialize(params)}`)
export const studioKeyRequestCreate = data => Http.post('/mail/key-requests-studio', data)
export const studioKeyRequestPreview = data => Http.post('/mail/key-requests-studio/preview', data)
export const studioKeyRequestResolveGame = gameId => Http.get(`/mail/key-requests-studio/resolve/${gameId}`)
